import * as echarts from 'echarts';

import { ParameterTypeEnum } from '@commons/enums/parameter-type.enum';
import { IConfigChartParams } from '../../interfaces/chart-params.interface';

export const PARAM_CHART_IGNITION_CONFIG: IConfigChartParams = {
  type: ParameterTypeEnum.Ignition,
  chartType: 'line',
  config: {
    areaStyle: {
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        {
          offset: 0,
          color: 'rgba(54, 161, 106, 0.30)'
        },
        {
          offset: 1,
          color: 'rgba(54, 161, 106, 0.30)'
        }
      ])
    },
    step: 'end',
    color: '#36e36a',
    unit: '',
  },
  yAxisConfig: {
    type: 'value',
    show: false,
  }
};

export const PARAM_CHART_FUEL_CONFIG: IConfigChartParams = {
  type: ParameterTypeEnum.Fuel,
  chartType: 'line',
  yAxisConfig: {
    type: 'value',
  },
  config: {
    unit: 'l',
    color: '#624E88',
  }
};

export const PARAM_CHART_SPEED_CONFIG: IConfigChartParams = {
  type: ParameterTypeEnum.Speed,
  chartType: 'line',
  yAxisConfig: {
    type: 'value'
  },
  config: {
    unit: 'km/h',
    color: '#5c86ab',
  }
};

export const PARAM_CHART_ENGINE_SPEED_CONFIG: IConfigChartParams = {
  type: ParameterTypeEnum.EngineSpeed,
  chartType: 'line',
  yAxisConfig: {
    type: 'value'
  }, 
  config: {
    unit: 'rpm',
    color: '#CC2B52',
  }
};

export const PARAM_CHART_TEMPERATURE_CONFIG: IConfigChartParams = {
  type: ParameterTypeEnum.Temperature,
  chartType: 'line', 
  yAxisConfig: {
    type: 'value'
  }, 
  config: {
    unit: '°C',
    color: '#B56B45',
  }
};

export const PARAM_CHART_VOLTAGE_CONFIG: IConfigChartParams = {
  type: ParameterTypeEnum.Voltage,
  chartType: 'line',
  yAxisConfig: {
    type: 'value'
  }, 
  config: {
    unit: 'V',
    color: '#2B3A67',
  }
}

export const PARAM_CHART_BINARY_CONFIG: IConfigChartParams = {
  type: ParameterTypeEnum.Binary,
  chartType: 'line',
  yAxisConfig: {
    type: 'value',
    show: false,
  },
  config: {
    unit: '',
    color: '#E6C79C',
  }
};

export const PARAM_CHART_ANALOG_CONFIG: IConfigChartParams = {
  type: ParameterTypeEnum.Analog,
  chartType: 'line',
  yAxisConfig: {
    type: 'value'
  },
  config: {
    unit: '',
    color: '#748251',
  }
};

export const PARAM_CHART_DISTANCE_CONFIG: IConfigChartParams = {
  type: ParameterTypeEnum.Distance,
  chartType: 'line',
  yAxisConfig: {
    type: 'value'
  },
  config: {
    unit: '',
    color: '#7B9EA8',
  }
};

export const PARAM_CHART_VISIBLE_SATELLITES_CONFIG: IConfigChartParams = {
  type: ParameterTypeEnum.VisibleSatellites,
  chartType: 'line',
  yAxisConfig: {
    type: 'value'
  },
  config: {
    unit: '',
    color: '#78586F',
  }
};

export const PARAM_CHART_GSM_LEVEL_CONFIG: IConfigChartParams = {
  type: ParameterTypeEnum.GSMLevel,
  chartType: 'line',
  yAxisConfig: {
    type: 'value'
  },
  config: {
    unit: '',
    color: '#31CB00',
  }
};
